var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper pa-4"},[_c('h1',[_vm._v("js数组")]),_c('p',[_c('a',{attrs:{"href":"https://wangdoc.com/javascript/types/array"}},[_vm._v("https://wangdoc.com/javascript/types/array")])])])
}]

export { render, staticRenderFns }